import * as claimInfo from "./claimInfo";

export default {
    ...claimInfo,
};
